import type {PublicPartnerProfile} from '../../../services/public-profile.service'

export function hasPublicProfileDetails(profile: PublicPartnerProfile | null | undefined): boolean {
    if (!profile) return false

    return Boolean(
        hasText(profile.descriptionHtml)
        || hasText(profile.logoUrl)
        || hasAddressDetails(profile)
        || hasContactDetails(profile)
        || hasSocialDetails(profile)
        || profile.openingHours.length > 0
    )
}

function hasAddressDetails(profile: PublicPartnerProfile): boolean {
    return Boolean(
        hasText(profile.address.street)
        || hasText(profile.address.postalCode)
        || hasText(profile.address.city)
        || hasText(profile.address.directions)
        || Number.isFinite(profile.address.latitude)
        || Number.isFinite(profile.address.longitude)
    )
}

function hasContactDetails(profile: PublicPartnerProfile): boolean {
    return Boolean(
        hasText(profile.contact.phone)
        || hasText(profile.contact.email)
        || hasText(profile.contact.websiteUrl)
    )
}

function hasSocialDetails(profile: PublicPartnerProfile): boolean {
    return Boolean(
        hasText(profile.socialLinks.instagramUrl)
        || hasText(profile.socialLinks.facebookUrl)
    )
}

function hasText(value: string | null | undefined): boolean {
    return Boolean(value?.trim())
}
